import { appModules } from '../services/licence.service';
import { Roles } from '../utility/role';
import { MenuSubItem } from './menu-subitem.model';
import { MenuItem } from './menu.item.model';

export const users: MenuSubItem[] = [
  {
    icon: 'people',
    route: '/schedule',
    name: 'nav.schedule',
    module: appModules.users,
  },
  {
    icon: 'people',
    route: '/users',
    name: 'nav.userManagement',
    roles: [Roles.contractorAdmin],
  },
];

export const items: MenuItem[] = [
  {
    icon: 'home',
    name: 'nav.home',
    route: '/home',
  },
  {
    icon: 'albums',
    route: '/clients',
    name: 'nav.clients',
  },
  {
    icon: 'business',
    name: 'nav.sites',
    route: '/worker/sites',
  },
  {
    icon: 'document',
    name: 'sites.tickets',
    route: '/worker/tickets',
  },
  {
    icon: 'people',
    name: 'nav.personel',
    children: users,
  },
  {
    icon: 'newspaper',
    route: '/news',
    name: 'nav.news',
    module: appModules.essentials,
  },
];

export const contractorAdminMenu = {
  items,
};
